import { INTEGRATION_PROVIDERS } from '@vy/types';
import { useActivatedIntegration } from '../../../use-activated-integration';

export function useConnactEnabled() {
  return useActivatedIntegration(INTEGRATION_PROVIDERS.connact, {
    suspense: true,
  });
}
